module.exports = __webpack_public_path__ + "img/2.6835fa93.jpg";